import React from 'react';
import { Button, Paper } from '@material-ui/core';
import { _T } from '../../../include/appI18n';
import { appUrl } from '../../../include/utils';
import { CapitalSearchTabs } from '../../../include/react-components/capital/CapitalSearchTabs';
import { useCapitalExpandedFilters } from '../../../include/react-components/capital/useCapitalExpandedFilters';
export function CapitalHotelSearchForm({ controls, switches, onSearch }) {
    const [expanded, setExpanded] = useCapitalExpandedFilters();
    const search = React.createElement(Button, { className: "capital-hotel-search-submit", variant: "contained", color: "secondary", onClick: onSearch }, _T.COMMON_SEARCH_VERB);
    return React.createElement(React.Fragment, null,
        React.createElement(CapitalSearchTabs, { active: "hotels" }),
        React.createElement(Paper, { className: `capital-search-panel capital-hotel-search-form${expanded ? ' is-expanded' : ''}` },
            React.createElement("div", { className: "capital-search-switches" }, switches),
            React.createElement("div", { className: "capital-hotel-main-fields" },
                controls.country,
                controls.region,
                controls.dates,
                controls.tourists,
                !expanded ? search : null),
            React.createElement("div", { id: "capital-hotel-extra-filters", className: "capital-search-extra-fields", hidden: !expanded },
                controls.city,
                controls.pansion,
                controls.star,
                controls.hotel),
            React.createElement("div", { className: "capital-search-tools" },
                React.createElement(Button, { "aria-expanded": expanded, "aria-controls": "capital-hotel-extra-filters", onClick: () => setExpanded(!expanded) },
                    React.createElement("img", { src: appUrl('/Content/capital/assets/search-filters.svg'), alt: "" }),
                    expanded ? _T.CAPITAL_HIDE_FILTERS : _T.CAPITAL_SHOW_FILTERS)),
            expanded ? React.createElement("div", { className: "capital-search-actions" }, search) : null));
}
